import Page from '@/components/page.vue'
import addHb from '../components/addDetail.vue'
import Preview from '../components/preview.vue'
import DelData from '@/components/delToast.vue'
import { zzsh } from '@/axios'
import { Message } from 'element-ui'
let that;
export default{
	data(){
		return{
			info:"",
			tableData:[],
			totalPage:0,
			isTable:1,
			type:"add",
			showPre:false,
			page:1,
			imgList:[],
			bsid:1,
		}
	},
	components:{Page,addHb,DelData,Preview},
	mounted() {
		that.dataList();
	},
	created(){
		that = this;
	},
	methods:{
		// 分页请求
		changePage(current){
			that.page = current;
			that.tableData = [];
			that.dataList();
		},
		// 清空数据
		clearTable(){
			that.page = 1;
			that.tableData = [];
			that.totalPage = 0
		},
		// 预览
		showDetail(data){
			that.bsid = data.bsid 
			if(data.bsid == 1){
				that.imgList = data.ment_url;
			}else if(data.bsid == 8){
				that.imgList = data.ment_url[0];
			}else{
				Message.warning('文件暂不支持在线预览')
			}
		},
		// 年份筛选
		selectYear(value){
			let query = Object.assign(this.$route.query,{year: value} )
			that.$router.push({query});
			that.clearTable();
			that.dataList();
		},
		// 编辑
		edit(data){
			this.type = 'edit';
			this.$refs.addhb.bindData(data);
		},
		// 删除
		del(data){
			that.$refs.delDatas.showToast(res => {
				if(res){
					zzsh.delThoughtFile({
						uid:that.$route.query.uid,
						id:data.id
					}).then(res => {
						if(res.code == 200){
							Message({
								type: 'success',
								message: '删除成功!'
							})
							that.dataList();
						}else{
							Message({
								type: 'error',
								message: res.msg
							})
						}
					})
				}
			})
		},
		// 获取数据
		dataList(){
			zzsh.thoughtMemberDetail({
				uid:that.$route.query.uid,
				year:that.$route.query.year,
				page:that.page
			}).then(res => {
				if(res.code == 200){
					that.info = res.info;
					if(res.data.pagedata!=null){
						that.totalPage = res.data.count;
						if(res.data.pagedata.length > 0){
							that.tableData = res.data.pagedata
						}
					}
				}else{
					Message.error(res.msg)
				}
			})
		}
	}
}